"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MomentField = void 0;
var tslib_1 = require("tslib");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
var moment_1 = tslib_1.__importDefault(require("moment"));
/**
 * Decorate a field with moment format
 *
 * @constructor
 */
var MomentField = function () {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        if (value === null || value === undefined) {
                            Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, value, this, property);
                            return;
                        }
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, moment_1.default(value), this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.MomentField = MomentField;
//# sourceMappingURL=MomentField.js.map